/* ============================================================
   Wortlaut des Warenkorb-Hinweises — EINE Quelle für beide Stellen, an denen er steht:
   den Reisbalken im Warenkorb (assets/cart-rice-bar.js) und den kleinen Balken neben dem
   Warenkorb-Symbol im Header (assets/header-cart-bar.js).

   Ohne diese Datei stünden dieselben Sätze zweimal im Theme und liefen beim ersten
   Umformulieren auseinander — im Warenkorb hieße es dann anders als im Header.

   Geladen wird sie in sections/header.liquid, also auf JEDER Seite und vor beiden
   Skripten, die sie benutzen. Beide haben trotzdem eine eigene Rückfallebene, falls sie
   einmal fehlt.

   Die Beträge selbst stehen NICHT hier, sondern in snippets/cart-schwellen.liquid —
   dort hängen sie am Lieferland (Deutschland 100 €, Österreich 200 €, Schweiz 500 € und
   zusätzlich ein Höchstbestellwert von 999,99 €).
   ============================================================ */
(function () {
  'use strict';

  // Betrag mit nachgestelltem Zeichen — für Differenzen im Fließtext („Noch 8,01 € bis…“),
  // wo sich das Zeichen hinten natürlicher liest.
  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Betrag in der Schreibweise des Shops — Zeichen VOR dem Wert, wie es der money-Filter
  // ausgibt und wie die Summe im Warenkorb (.totals__total-value) aussieht.
  function betrag(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Der Hinweis in Worten. Reihenfolge ist Absicht: Zuerst der Höchstbestellwert, denn
  // darüber geht gar nichts mehr; dann der Mindestbestellwert, ohne den keine Bestellung
  // zustande kommt; erst danach der Versand.
  //
  // max ist ein Zusatz und darf fehlen — nur die Schweiz hat einen Höchstbestellwert.
  // 0 oder undefined bedeutet: keine Obergrenze.
  function text(total, min, free, max) {
    if (max && total >= max) return 'Maximaler Bestellwert erreicht';
    if (total < min) return 'Noch ' + euro(min - total) + ' bis zum Mindestbestellwert';
    if (total < free) return 'Noch ' + euro(free - total) + ' bis versandkostenfrei';
    return 'Versandkostenfrei erreicht';
  }

  // Derselbe Zustand als kurzes Wort, für die Farbgebung. Damit benutzen Warenkorb und
  // Header nachweislich dieselbe Einteilung und nicht zwei ähnliche.
  function stufe(total, min, free, max) {
    if (max && total >= max) return 'max';
    if (total < min) return 'min';
    if (total < free) return 'versand';
    return 'frei';
  }

  // Bezugsgröße des Balkens: Gibt es einen Höchstbestellwert, reicht die Skala bis dorthin
  // und der Versandkostenfrei-Betrag wird zu einer Marke DARIN. Ohne Obergrenze bleibt es
  // beim bisherigen Verhalten, wo der Balken bei versandkostenfrei voll ist.
  function skala(free, max) {
    return max && max > 0 ? max : free;
  }

  window.cartHinweis = {
    euro: euro,
    betrag: betrag,
    text: text,
    stufe: stufe,
    skala: skala
  };
})();
